import {Loader} from '@googlemaps/js-api-loader';
import $ from "jquery";

let map, markerList = [], marker;
let popup;
let mapsOverlay = $('.maps-overlay');
let legendItem = mapsOverlay.find('a');
let data = mapsOverlay.data('locations');
let center = {
    lat: 51.9484797,
    lng: 4.5423346
};

if (data?.[0].lat !== undefined && data?.[0].long !== undefined) {
    center = {
        lat: Number.parseFloat(data[0].lat),
        lng: Number.parseFloat(data[0].long),
    };
}
const loader = new Loader({
    apiKey: 'AIzaSyCfuR-3VCwQF8PZq7hxIC4-V8yOpP6Vz0Q',
    version: "weekly",
});


const mapOptions = {
    center: center,
    zoom: 16,
    mapId: "1",
    // scrollwheel: false,
    disableDefaultUI: true,
};

loader
    .load()
    .then(async (google) => {
        class Popup extends google.maps.OverlayView {
            position;
            containerDiv;

            constructor(position, content) {
                super();
                this.position = position;
                content.classList.add("popup-bubble");
                const bubbleAnchor = document.createElement("div");
                bubbleAnchor.classList.add("popup-bubble-anchor");
                bubbleAnchor.appendChild(content);
                this.containerDiv = document.createElement("div");
                this.containerDiv.classList.add("popup-container");
                this.containerDiv.appendChild(bubbleAnchor);
                Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
            }

            /** Called when the popup is added to the map. */
            onAdd() {
                this.getPanes().floatPane.appendChild(this.containerDiv);
            }

            onRemove() {
                if (this.containerDiv.parentElement) {
                    this.containerDiv.parentElement.removeChild(this.containerDiv);
                }
            }

            draw() {
                const divPosition = this.getProjection().fromLatLngToDivPixel(
                    this.position,
                );
                const popupHeight = 200;
                const popupWidth = 330;
                const offsetY = 60;
                const topPosition = divPosition.y - popupHeight - offsetY;
                const leftPosition = divPosition.x - (popupWidth / 2);

                this.containerDiv.parentElement.style.top = `${topPosition}px`;
                this.containerDiv.parentElement.style.left = `${leftPosition}px`;

                const display =
                    Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                        ? "block"
                        : "none";

                if (display === "block") {
                    this.containerDiv.style.left = divPosition.x + "px";
                    this.containerDiv.style.top = divPosition.y + "px";
                }

                if (this.containerDiv.style.display !== display) {
                    this.containerDiv.style.display = display;
                }
            }
            close() {
                this.containerDiv.style.display = 'none';
            }
        }

        const mapContainer = document.getElementById('opdrachtgevers_map');
        if (!mapContainer) {
            return false;
        }
        const {AdvancedMarkerElement} = await loader.importLibrary("marker");
        map = new google.maps.Map(mapContainer, mapOptions);
        popup = createPopup(data[0], center);

        data.forEach((location, indexLocation) => {
            const positionPoint = new google.maps.LatLng(location.lat, location.long);
            const marker = new AdvancedMarkerElement({
                map,
                position: positionPoint,
                id: indexLocation
            });
            if (marker) {
                marker.addListener("click", () => {
                    map.setCenter(marker.position);
                    popup = createPopup(data[indexLocation], positionPoint);
                });
                markerList.push(marker);
            }
        });

        /**
         * When click on legend
         * go to and open location
         */
        $(legendItem).on('click', function (e) {
            let $this = $(this);
            let gmapsID = $this.data('gmaps-id');
            if ($this.hasClass('hover'))
                return false;

            if (!$this.hasClass('hover')) {
                closePopup();
                google.maps.event.trigger(markerList[gmapsID], 'click');
            } else {
                closePopup();
                $this.removeClass('hover');
            }
            return false;
        });


        const closePopup = function () {
            popup.close();
            removeLegendClasses();
        };
        function removeMarker() {
            markerList.forEach(marker=> {
                marker.setMap(null);
            })
        }

        google.maps.event.addListener(map, "click", function () {
            closePopup();
        });

        function createPopup(data, position) {
            const popupElement = createAndFillPopupElement(data);

            popup = new Popup(
                position,
                popupElement,
            );
            popup.setMap(map);

            return popup;
        }

    })
    .catch(e => {
    });

const removeLegendClasses = function () {
    $(legendItem).removeClass('hover');
};

function createAndFillPopupElement(data) {
    const popupElement = document.getElementById("map-popup-content");
    const titleElement = popupElement.querySelector(".js-maps-title");
    titleElement.innerHTML = data?.title;
    const addressElement = popupElement.querySelector(".js-maps-address");
    addressElement.innerHTML = data?.address;
    const emailElement = popupElement.querySelector(".js-maps-email");
    emailElement.innerHTML = data?.email;
    const phoneElement = popupElement.querySelector(".js-maps-phone");
    phoneElement.innerHTML = data?.tel;

    return popupElement;
}